import {
  ENTER_OTP_VALUE,
  OTP_SENT,
  get_request_config
} from '@/utils/system_constants/constant.js';
import axios from 'axios';
import OnboardingIndex from '../OnboardingIndex.vue';
import alert_mixin from '@/utils/mixins/alert_mixin';
import { get_api_error_message, get_api_response_message, parse_api_data } from '@/utils/api_error_message';
import { validate_numbers } from '@/utils/mixins/validate_inputs';

const REQUESTOR_ROLE_MATCHERS = ['entity', 'requestor', 'requester'];
const OWNER_ROLE_MATCHERS = ['case owner', 'case_owner'];

function normalize_role(role) {
  return String(role || '').trim().toLowerCase();
}

function is_applicant_role(normalized_role) {
  return normalized_role === 'entity';
}

const is_requestor_role = (normalized_role) =>
  REQUESTOR_ROLE_MATCHERS.some((role_matcher) => normalized_role.includes(role_matcher));

const is_owner_role = (normalized_role) =>
  OWNER_ROLE_MATCHERS.some((role_matcher) => normalized_role.includes(role_matcher))
  || normalized_role === 'owner'
  || normalized_role.endsWith(' owner');

const ONBOARDING_SYSTEM_HOME_ROUTE = 'CommandCentre';

export default {
  name: 'OneTimePin',
  mixins: [alert_mixin],
  components: {
    OnboardingIndex
  },
  data() {
    return {
      title: "Verify Your Account",
      submit_button_text: "Login",
      verification_running: false,
      otp_number: '',
      otp_sending: false
    };
  },

  computed: {
    post_otp_route_name() {
      const normalized_role = normalize_role(this.$store.getters.currentRole);

      if (is_applicant_role(normalized_role)) {
        return 'MyQueue';
      }

      if (is_requestor_role(normalized_role)) {
        return this.$router.hasRoute('RequestorDashboard')
          ? 'RequestorDashboard'
          : ONBOARDING_SYSTEM_HOME_ROUTE;
      }

      if (is_owner_role(normalized_role)) {
        return this.$router.hasRoute('OwnerDashboard')
          ? 'OwnerDashboard'
          : ONBOARDING_SYSTEM_HOME_ROUTE;
      }

      return this.$router.hasRoute('CompanyPortfolio')
        ? 'CompanyPortfolio'
        : ONBOARDING_SYSTEM_HOME_ROUTE;
    }
  },

  methods: {
    validate_numbers,
    async handle_enter_otp() {
      if (!this.otp_number) {
        this.show_error('Please enter your OTP.');
        return;
      }

      this.verification_running = true;

      const data = {
        one_time_password: this.otp_number,
        user_id: this.$store.getters.currentUserId
      };

      try {
        const response = await axios.post(
          ENTER_OTP_VALUE,
          data,
          get_request_config()
        );

        const response_data = parse_api_data(response.data);

        if (response_data.status === 'success') {
          sessionStorage.setItem('otp_verified', 'true');
          this.show_success('OTP verified successfully');
          await this.$router.replace({ name: this.post_otp_route_name });
        } else {
          this.show_error(get_api_response_message(response_data, 'Error during OTP verification'));
        }
      } catch (error) {
        this.show_error(get_api_error_message(error, 'Please enter a valid OTP.'));
      } finally {
        this.verification_running = false;
      }
    },

    async resend_otp() {
      if (this.otp_sending) return;

      this.otp_sending = true;
      const user_id = this.$store.getters.currentUserId;

      try {
        const response = await axios.post(
          OTP_SENT,
          { user_id },
          get_request_config()
        );

        const response_data = parse_api_data(response.data);

        if (response_data.status === 'success') {
          this.show_success('OTP has been resent successfully.');

          if (response_data.user_id) {
            this.$store.dispatch('setCurrentUserId', response_data.user_id);
          }
        } else {
          this.show_error(get_api_response_message(response_data, 'Could not send OTP.'));
        }
      } catch (error) {
        this.show_error(get_api_error_message(error, 'Could not send OTP to user.'));
      } finally {
        this.otp_sending = false;
      }
    }
  }
};
